/**
 * @flow
 * */
import styled, { css } from 'react-emotion'
import { mobile, tablet, desktop } from '../../../../utils/mixins'
import CloudinaryS3Image from '../../../CloudinaryS3Image'

export const GalleryThumbnailImage = styled(CloudinaryS3Image)`
  box-sizing: border-box;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
  ${mobile} {
    width: 2.857em;
    height: 2.857em;
  }
  ${tablet} {
    width: 3.75em;
  }
  ${desktop} {
    width: 6.25em;
  }
`

export const GalleryThumbnailImageContainer = styled.div`
  ${mobile} {
    width: 2.857em;
    height: 2.857em;
    margin-right: 0.536em;
    margin-left: 0.536em;
  }
  ${tablet} {
    width: 3.75em;
    height: 3.75em;
    margin-right: 0.75em;
  }
  ${desktop} {
    width: 6.25em;
    height: 6.25em;
    margin-right: 0.4063em;
    margin-left: 0.4063em;
  }
`

export const selectedThumbnail = css`
  border: 0.125em solid #fff;
`



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/ThumbnailImage/styledComponents.js